import LandingNavigation from "./navigation"

export default LandingNavigation
